import * as React from 'react';
import { forwardRef, memo } from 'react';

const SvgMailIcon = (props, ref) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      d="M4 6h16v12H4V6Z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="m4 6 7.4 5.55a1 1 0 0 0 1.2 0L20 6"
      stroke="currentColor"
      strokeWidth={1.5}
    />
  </svg>
);

const ForwardRef = forwardRef(SvgMailIcon);
const Memo = memo(ForwardRef);
export default Memo;
